import { BaseControl } from "../base-control";

class NumericControlCtrl extends BaseControl {
  constructor(BaseControlService, $scope) {
    'ngInject';
    super(BaseControlService, $scope);
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/numeric-control/numeric-control.component.html",
  controller: NumericControlCtrl
};